import { useCallback } from 'react';
import { PlanPermissionResponse, PlanPermissionKey } from '@common/types/plan';
import api from '@common/configs/api';
import { API_ENDPOINTS } from '@common/constants/apiEndpoint';
import { AxiosResponse } from 'axios';
import { useDispatch } from 'react-redux';
import { setPlanPermission } from '@common/redux/slice/planPermission';
import { showAlert } from '@common/utils/ShowAlert';

export const usePlanPermission = () => {
  const dispatch = useDispatch();
  const _checkShowPlanModalByNumberOfRecords = useCallback(
    async (appid: string) => {
      const {
        data: permissionResponse,
      }: AxiosResponse<PlanPermissionResponse> = await api({
        method: 'get',
        url: API_ENDPOINTS.PLAN_PERMISSION,
        params: {
          keys: [PlanPermissionKey.numberOfRecords],
          appid,
        },
      });
      if (permissionResponse.numberOfRecords) {
        if (
          permissionResponse.numberOfRecords.current >=
          permissionResponse.numberOfRecords.max
        ) {
          dispatch(setPlanPermission(permissionResponse));
          showAlert(
            'プランの上限を超えています。管理者に問い合わせてください。'
          );
          return false;
        }
      }
      return true;
    },
    []
  );

  const checkShowPlanModalByNumberOfRecords = useCallback(
    async (appid: string) => {
      try {
        await _checkShowPlanModalByNumberOfRecords(appid);
      } catch (error) {
        console.error('===checkShowPlanModalByNumberOfRecords error', error);
        showAlert(
          'アプリが起動できません。電波状況が良好なエリアで再度実行してください。'
        );
      }
    },
    []
  );

  return {
    checkShowPlanModalByNumberOfRecords,
  };
};
